/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getIndexBy = function getIndexBy(data, by, id, getItemId, compoundIdProperty) {
  var index = -1;
  for (var i = 0, len = data.length; i < len; i++) {
    var item = data[i];
    var itemId = compoundIdProperty ? getItemId(item) : item[by];
    var parsedId = typeof itemId === 'number' ? Number(id) : id;
    if (itemId === parsedId) {
      index = i;
      break;
    }
  }
  return index;
};
var _default = getIndexBy;
exports.default = _default;